import { Text } from "@radix-ui/themes";
import { FC, JSX } from "react";
import { Link } from "react-router-dom";
import { ToastContentProps } from "react-toastify";

const PrecisionGameToastSuccess: FC<ToastContentProps> = ({
  closeToast,
}): JSX.Element => {
  return (
    <div onClick={closeToast}>
      <Text as="p">
        🎉 Sådan! Du er nu med i lodtrækningen om en{" "}
        <Text weight="bold"> PlayStation 4 - 20th Anniversary Edition</Text> til
        en værdi af 10.000 kr.{" "}
        <Link
          to="/profile-settings"
          style={{ color: "black", textDecoration: "underline" }}
          onClick={closeToast}
        >
          Indtast din email adresse så vi kan kontakte dig.{" "}
        </Link>
      </Text>
    </div>
  );
};

export default PrecisionGameToastSuccess;
